import { Box, Card, Flex, Text } from '@chakra-ui/react';
import NextImage, { StaticImageData } from 'next/image';
import { FC, ReactNode } from 'react';

interface IThumbnailIconCard {
  label: string;
  text: string;
  icon: ReactNode;
  thumbnail_url: StaticImageData;
}

export const ThumbnailIconCard: FC<IThumbnailIconCard> = ({ label, text, icon, thumbnail_url }) => {
  return (
    <Card
      overflow="hidden"
      flexDirection={{ base: 'row', lg: 'column' }}
      w="100%"
      h={{ base: '226px', lg: '400px' }}
      maxW={{ base: 'auto', lg: '390px' }}
      alignItems="center"
      borderRadius={8}
    >
      <Box
        position="relative"
        w={{ base: '83px', sm: '150px', lg: '100%' }}
        h={{ base: 'auto', sm: 'auto', lg: '170px' }}
        minH={{ base: '100%', sm: '100%', lg: '170px' }}
        flexShrink={0}
      >
        <NextImage src={thumbnail_url} alt={label} layout="fill" objectFit="cover" />
      </Box>
      <Flex
        color="black"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        h="full"
        px={{ base: 4, md: 6, lg: 8 }}
      >
        <Flex
          mb={3}
          borderRadius={8}
          justifyContent="center"
          alignItems="center"
          backgroundColor="violet.50"
          w={14}
          h={14}
        >
          {icon}
        </Flex>
        <Text fontFamily="heading" fontSize={{ base: 'md', lg: 'lg' }} fontWeight="bold">
          {label}
        </Text>
        <Text fontSize={{ base: 'sm', lg: 'm' }}>{text}</Text>
      </Flex>
    </Card>
  );
};
